export default "__VITE_ASSET__CRmtpPij__"